import React from "react";
import { Helmet } from "react-helmet-async";
import Image from "../Images/BIO.jpg";
import Image2 from "../Images/Installation01.JPG";
import Image3 from "../Images/Solo12image.jpg";
import { Container, Row, Col } from "react-bootstrap";
import "../Styles/Bio.css";

const Bio = () => {
  return (
    <>
      <Helmet>
        <title>Biography | Kazumi Sakoda</title>
        <meta
          name="description"
          content="Biography of Kazumi Sakoda, a Japanese sound artist based in Barcelona, including installations, interviews and live performances."
        />
      </Helmet>

      <Container>
        <Row>
          <Col md={2} />
          <Col md={8}>
            <img
              src={Image}
              id="kazumi1"
              className="img-fluid"
              alt="bioImage"
            />
          </Col>
        </Row>
        <Row>
          <Col md={2} />
          <Col md={8}>
            <h3>BIO</h3>
            <hr />
            <p className="text-center">
              Kazumi Sakoda is a Japanese sound artist based in Barcelona.
              Through field recordings, handmade cassette loops and a sampling
              keyboard, she creates immersive soundscapes from the everyday
              sounds of Barcelona city. Since 2019, she has been recording
              Barcelona as an ongoing sonic diary. Returning to the same places
              year after year, she listens to how the city changes over time.
              Some sounds disappear, others remain, and new ones quietly emerge.
              Rather than documenting the city as it is, her work explores how
              urban sound reflects the passing of time and the subtle
              transformations of everyday life. In live performances, these
              recordings are reassembled through cassette loops and sampling,
              creating evolving compositions that move between ambient,
              experimental and noise music.
            </p>
            <h3>Installation</h3>
            <hr />
            <img
              src={Image2}
              id="kazumi2"
              className="img-fluid"
              alt="InstallationImage"
            />
            <p>
              2022 Recorreguts Sonors, ”el bosque corrompido”, convento Sant
              Agustí
            </p>
          </Col>
        </Row>

        <Row>
          <Col md={2} />
          <Col md={8}>
            <h3>Interview</h3>
            <hr />
            <p className="text-center">
              2025 Radio Relativa Madrid “Amuletos :Hosted by Ana Banana DJ”{" "}
              <a
                href="https://radiorelativa.eu/episode/amuletos-w-kazumi-sakoda"
                target="blank"
              >
                Link
              </a>
              <br />
              2024 coffee magazine SOLO 12 “ The Sound Collector ” <br />
              2023 dublab BCN, Campo Base 20.03.23 w/ Laura de Díaz{" "}
              <a
                href="https://www.mixcloud.com/dublabes/campo-base-200323-w-laura-de-díaz/
"
                target="blank"
              >
                Link
              </a>
              <br />
              2023 Irradia sonora podcast{" "}
              <a
                href="https://open.spotify.com/episode/1sySWHnCcLCLlOfxKT6va2?si=e085d853a9a546b8
"
                target="blank"
              >
                Link
              </a>
              <br />
              2023 Laundry Day Soundscapes vol 3{" "}
              <a
                href="https://laundryday.net/blogs/journal/soundscapes-volume-3-a-conversation-with-kazumi"
                target="blank"
              >
                Link
              </a>
              <br />
              2022 El prat rádio, Rastros de Carmín, Barcelona 26 set, 2022{" "}
              <a
                href="https://www.elprat.digital/radio/rastros-de-carmin-63/"
                target="blank"
              >
                Link
              </a>
              <img
                src={Image3}
                id="kazumi1"
                className="img-fluid"
                alt="bioImage"
              />
            </p>
          </Col>
        </Row>

        <Row>
          <Col md={2} />
          <Col md={8}>
            <h3>Live / Work</h3>
            <hr />
            <p className="text-center">
              2026 “Sampling barcelona 2022-24 “, DIGIT Festival, Pratdip (Tarragona)
              <br />
              2026 “Osenchi Tokyo” for Oblicuo hi-fi bar, Barcelona
              <br />
              2026 “Sampling barcelona for Komuso”, Komuso, Barcelona
              <br />
              2026 “Sampling barcelona 2022-2023”, La Automatica, Barcelona
              <br />
              2025 “dorops” for the film "Solo la sombra" directed by Enric
              Ribes
              <br />
              2024 “Sampling barcelona 2023”, La terraza, Barcelona
              <br />
              2024 “Sampling barcelona 2023”, Casa Munjuic, Barcelona
              <br />
              2024 “ No querías café, de verdad ” for SOLO 12 magazine, Valencia
              is coffee, Valencia
              <br />
              2024 “ Listen To The Land Until It Becomes Your Body ”, Proyecto
              Nulo, Valencia
              <br />
              <br />
              2023 “ Listen To The Land Until It Becomes Your Body ”, Niu,
              Barcelona
              <br />
              2023 “Listen To The Land Until It Becomes Your Body” Pre-release
              party, Radas studio, Barcelona <br />
              2023 Affine Dark Science on IDA Helsinki 18.08.23{" "}
              <a
                href="https://soundcloud.com/ida_radio/affine-dark-science-with-kazumi-sakoda-laura-mrls-180823"
                target="blank"
              >
                Link
              </a>
              <br />
              2023 HOC radio #154{" "}
              <a
                href="https://soundcloud.com/hoc-radio/set-154-kazumi-sakoda?si=eb33ed31a2f04d10a5042316bbca02d3&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing
              "
                target="blank"
              >
                Link
              </a>
              <br />
              2023 Epifenómeno,”Sampling BarcelonaII二” y “VHS terminal”, FOC ,
              Barcelona
              <br />
              2023 Ruiod O Poesía , Live with Pilar Talavera(spoken word),
              Meteoro, Barcelona
              <br />
              2023 Zona Watusa presents, "Sampling BarcelonaII二", Barcelona
              <br />
              2023 MOSTRA ,”Sampling Barcelona” y “VHS terminal”, Hangar.org,
              Barcelona{" "}
              <a
                href="https://soundcloud.com/mostrabcn/kazumi-sakoda-live-mostra-2023?si=c1fe94e2a9ca456ba1cfd5716536cad0&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing"
                target="blank"
              >
                Link
              </a>
              <br />
              2023 APS, Live with Mohamed Khtira (Gnawa music), Meteoro,
              Barcelona
              <br />
              <br />
              2022 Live at Flushing Toilets collaborated Museo de Arte UNMSM{" "}
              <a href="https://youtu.be/fgxIPZr8k-o" target="blank">
                Link
              </a>
              <br />
              2022 Teorema Festival Barcelona 2022, "tokyo-barcelona", Barcelona
              <br />
              2022 MIND FEST, "tokyo-barcelona", Castell d'Amposta <br />
              2022 Zona Watusa Festival 5to anniversario,"Osenchi Tokyo",
              Barcelona
              <br />
              2022 街のノイズ, "Lantern", slow room, Gifu Cassette Jam Session
              <a
                href="https://soundcloud.app.goo.gl/hwJMrEVdKSRj4R7r7"
                target="blank"
              >
                Link
              </a>
              <br />
              2022 屋上環境音02, "Lantern", Shibuya valley, Tokyo <br />
              2022 TeslaFM Deltagrama #5 - Soul Twin
              <a
                href="https://www.mixcloud.com/Teslafm_net/deltagrama-5-soul-twin/"
                target="blank"
              >
                {" "}
                Link
              </a>
              <br />
              2022 Streaming live at SubRadio , "Lantern", Barcelona
              <a href="https://youtu.be/638UDoMve4c" target="blank">
                {" "}
                Link
              </a>
              <br />
              2022 Teorema Festival Barcelona, ”Lantern”, Barcelona <br />
              2022 IWD | MUTEK Barcelona Edition 13, "Lantern", Casa Bonay,
              Barcelona
              <br />
              <br />
              2021 Teorema Festival Barcelona, ”el bosque corrompido”, Barcelona
              <br />
              2020 KRONOS ART BCN, "being alive" with Noman from Tokyo with
              Zoom, Santa Mònica
              <br />
              2020 三元茶会 | 禊伽mitogi, "Pl.Cataluña - Badalona" , Zoom, Tokio
              <br />
            </p>
          </Col>
        </Row>
        <div className="BioFooter">
          <p>© KAZUMI SAKODA 2025</p>
        </div>
      </Container>
    </>
  );
};

export default Bio;
